import type { Order, Sendung } from "../../lib/types.ts";
import type { StatusDefinitionen } from "../../lib/status.ts";
import { sendungenAbbilden, zeitstrahlBestellkennungen } from "../../lib/bestandQuellen.ts";
import { sendungenZuBestellungenLaden } from "../../api/sendungen.ts";

// Die Auswahl der Bestellungen und die Abbildung der Treffer sind reine Funktionen in `lib/bestandQuellen.ts` (der Server des
// KI-Zugangs fährt dieselben Schritte).

/**
 * Sichtbarkeit wie ZeitstrahlSeite, vor lokaler Textsuche. Abgeleitete JTL-IDs
 * haben keine Hub-Verknüpfung und bleiben draußen (BE-10245, 25.08.2026).
 * Leere Auswahl lädt nicht. Zustand und Race-Schutz gehören dem Aufrufer in App.
 * Historische Entscheidungen zur Sammelroute:
 * docs/superpowers/specs/2026-10-12-app-fachliche-schnitte-design.md.
 *
 * `hintergrund`: die Anwendung laedt von selbst nach, der Mensch hat nichts getan
 * (`AnfrageOptionen.hintergrund`). Nur bei `true` an die Anfrage weitergereicht: der Normalfall
 * (Handlung des Menschen) ruft `sendungenZuBestellungenLaden` unveraendert mit EINEM Argument.
 */
export function zeitstrahlSendungenLaden(
  bestellungen: Order[],
  definitionen: StatusDefinitionen,
  hintergrund?: boolean,
): Promise<Record<string, Sendung | null>> {
  const orderIds = zeitstrahlBestellkennungen(bestellungen, definitionen);
  if (orderIds.length === 0) return Promise.resolve({});
  const abruf = hintergrund
    ? sendungenZuBestellungenLaden(orderIds, undefined, true)
    : sendungenZuBestellungenLaden(orderIds);
  return abruf.then((geladen) => sendungenAbbilden(geladen));
}
